import request from '@/umi-request';
import { AxiosPromise } from 'axios';
import { PaginatedResponse } from '@/interfaces/response';
import { Prescription, PrescriptionProduct, Voucher, AffiliateDeleteConsumptions, AffiliateVouchersBiochemists, Product } from '@/interfaces/consumptions';
import { Receipt, Ticket, Voucher as FileVoucher } from '@/interfaces/files';

// Recibos de farmacia
export async function getAffiliatePharmaciesConsuptions(id: number, params: any = {}) {
  return request({
    url: `affiliates/${id}/pharmacy-prescriptions/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Prescription>>;
}

export async function getPharmaciesConsuptions(params: any = {}) {
  return request({
    url: `pharmacy-prescriptions/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Prescription>>;
}

// Productos de farmacia
export async function getPharmaciesProducts(params: any = {}) {
  return request({
    url: `pharmacy-prescriptions-products/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<PrescriptionProduct>>;
}

export async function getPharmaciesTopByCount(params: any = {}) {
  return (request({
    url: `pharmacy-prescriptions/top-20-pharmacy-count/`,
    method: 'GET',
    params,
  }) as AxiosPromise<AffiliateVouchersBiochemists[]>).then((response) =>
    response.data.map((r) => ({
      name: `${r.pharmacy__name}, ${r.pharmacy__locality}`,
      value: r.count,
    })),
  );
}

export async function getPharmaciesTopBySum(params: any = {}) {
  return (request({
    url: `pharmacy-prescriptions/top-20-pharmacy-sum/`,
    method: 'GET',
    params,
  }) as AxiosPromise<AffiliateVouchersBiochemists[]>).then((response) =>
    response.data.map((r) => ({
      name: `${r.pharmacy__name}, ${r.pharmacy__locality}`,
      value: `$${r.total}`,
    })),
  );
}

export async function getPharmaciesProductsTopByCount(params: any = {}) {
  return (request({
    url: `pharmacy-prescriptions-products/top-20-products-count/`,
    method: 'GET',
    params,
  }) as AxiosPromise<Product[]>).then((response) => response.data.map((r) => ({ name: `${r.product__name}`, value: r.count })));
}

export async function getPharmaciesProductsTopBySum(params: any = {}) {
  return (request({
    url: `pharmacy-prescriptions-products/top-20-products-sum/`,
    method: 'GET',
    params,
  }) as AxiosPromise<Product[]>).then((response) => response.data.map((r) => ({ name: `${r.product__name}`, value: `$${r.total}` })));
}

// Bonos de Laboratorio
export async function getAffiliateBiochemistsVouchers(id: number, params: any = {}) {
  return request({
    url: `affiliates/${id}/biochemists-vouchers/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Voucher>>;
}

export async function getBiochemistsVouchers(params: any = {}) {
  return request({
    url: `biochemists-vouchers/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Voucher>>;
}

// Prácticas de Laboratorio
export async function getAffiliateBiochemistsVouchersDetails(id: number, params: any = {}) {
  return request({
    url: `affiliates/${id}/biochemists-vouchers-details/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Voucher>>;
}

export async function getBiochemistsVouchersDetails(params: any = {}) {
  return request({
    url: `biochemists-vouchers-details/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Voucher>>;
}

// Tickets
export async function getTickets(params: any = {}) {
  return request({
    url: `tickets/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Ticket>>;
}

export async function getTicketOcurrencies(id: number) {
  return request({
    url: `tickets/${id}/occurrences/`,
    method: 'GET',
  }) as AxiosPromise<number>;
}

export async function getTicketCheckKey(id: number, params: any) {
  return request({
    url: `tickets/${id}/check-key-ticket/`,
    method: 'GET',
    params,
  }) as AxiosPromise<Ticket[]>;
}

export async function validateTicket(id: number) {
  return request({
    url: `tickets/${id}/verify/`,
    method: 'PUT',
  }) as AxiosPromise<Ticket>;
}

export async function rejectTicket(id: number) {
  return request({
    url: `tickets/${id}/reject/`,
    method: 'PUT',
  }) as AxiosPromise<Ticket>;
}

// Receipts
export async function getReceipts(params: any = {}) {
  return request({
    url: `receipts/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<Receipt>>;
}

export async function getReceiptOcurrencies(id: number) {
  return request({
    url: `receipts/${id}/occurrences/`,
    method: 'GET',
  }) as AxiosPromise<number>;
}

export async function getReceiptCheckKey(id: number, params: any) {
  return request({
    url: `receipts/${id}/check-key/`,
    method: 'GET',
    params,
  }) as AxiosPromise<Receipt[]>;
}

export async function validateReceipt(id: number) {
  return request({
    url: `receipts/${id}/verify/`,
    method: 'PUT',
  }) as AxiosPromise<Receipt>;
}

export async function rejectReceipt(id: number) {
  return request({
    url: `receipts/${id}/reject/`,
    method: 'PUT',
  }) as AxiosPromise<Receipt>;
}

// Bonos
export async function getVouchers(params: any = {}) {
  return request({
    url: `vouchers/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<FileVoucher>>;
}

export async function getVoucherOcurrencies(id: number) {
  return request({
    url: `vouchers/${id}/occurrences/`,
    method: 'GET',
  }) as AxiosPromise<number>;
}

export async function getVoucherCheckKey(id: number, params: any) {
  return request({
    url: `vouchers/${id}/check-key-voucher/`,
    method: 'GET',
    params,
  }) as AxiosPromise<Voucher[]>;
}
export async function validateVouchers(id: number) {
  return request({
    url: `vouchers/${id}/verify/`,
    method: 'PUT',
  }) as AxiosPromise<FileVoucher>;
}

export async function rejectVoucher(id: number) {
  return request({
    url: `vouchers/${id}/reject/`,
    method: 'PUT',
  }) as AxiosPromise<FileVoucher>;
}

export async function deleteVoucher(id: number) {
  return request({
    url: `vouchers/${id}/`,
    method: 'DELETE',
  }) as AxiosPromise<AffiliateDeleteConsumptions>;
}

export async function deleteReceipt(id: number) {
  return request({
    url: `receipts/${id}/`,
    method: 'DELETE',
  }) as AxiosPromise<AffiliateDeleteConsumptions>;
}

export async function deleteTicket(id: number) {
  return request({
    url: `tickets/${id}/`,
    method: 'DELETE',
  }) as AxiosPromise<AffiliateDeleteConsumptions>;
}